var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFluentPeople48Filled = function SvgFluentPeople48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.667 10a3.333 3.333 0 1 0 0-6.667 3.333 3.333 0 0 0 0 6.667m7.5 0a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M2.813 11.25a1.563 1.563 0 0 0-1.563 1.563v.52s0 3.75 5.417 3.75 5.416-3.75 5.416-3.75v-.52a1.563 1.563 0 0 0-1.562-1.563zm9.135 4.62c.573.233 1.3.38 2.218.38 4.375 0 4.375-3.333 4.375-3.333v-.104a1.563 1.563 0 0 0-1.562-1.563h-4.643c.375.434.58.989.58 1.563v.563l-.003.062a4.171 4.171 0 0 1-.115.731 4.5 4.5 0 0 1-.85 1.701"
  })));
};
export default SvgFluentPeople48Filled;